import React, { ReactNode, Suspense } from 'react';
import { useAsyncResource } from 'use-async-resource';
import { onNgReady } from '../../utils/ng.utils';
import { angularService } from '../../utils/angularBridge';

async function getAngularReady(configUrl: string = '') {
    await onNgReady();
    await angularService('zConfig').getConfig(window.config || configUrl);

    return true;
}

export type AngularReadyProps = {
    children: ReactNode;
    fallback: NonNullable<ReactNode> | null;
    configUrl?: string;
};

export function AngularReady({ children, fallback, configUrl }: AngularReadyProps) {
    const [isReadyReader, getIsReadyReader] = useAsyncResource(
        () => getAngularReady(configUrl),
        [],
    );

    return (
        <Suspense fallback={fallback}>
            <AngularReadyInner isReadyReader={isReadyReader}>{children}</AngularReadyInner>
        </Suspense>
    );
}

function AngularReadyInner({ children, isReadyReader }) {
    const isReady = isReadyReader();

    return <>{isReady ? children : null}</>;
}
